import { makeStyles } from 'tss-react/mui';

const useStylesHashBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  hashBlock: {
    border: `solid 1px ${theme.palette.common.black}`,
    padding: 10,
    wordBreak: 'break-all',
  },
}));

export default useStylesHashBlock;
